"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elLocaleData = require("i18next-icu/locale-data/el");
exports.default = elLocaleData;
//# sourceMappingURL=el.js.map